// src/pages/VideosGallery.js 
// (Assuming this file contains your VideosGallery component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
// NotificationBar was in the original useMeta import block but not in the return JSX, 
// so it is excluded from the imports for cleanliness.

// Page Component
import VidGalleryContent from './PageComponent/VidGalleryContent';

function VideosGallery() {

  // The useMeta hook call is removed and its content is moved into <Helmet>
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Videos Gallery | Marvel Blinds</title>
        <meta
          name="description"
          content="Explore our video gallery to see the latest adventures and lifestyle tips. Dive in and find inspiration today!"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/videos-gallery/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Videos Gallery" />
        <meta
          property="og:description"
          content="Explore our video gallery to see the latest adventures and lifestyle tips. Dive in and find inspiration today!"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/videos-gallery/`} />
        <meta property="og:site_name" content="Marvel Blinds" />
      </Helmet>

      {/* Rest of your component structure */}
      <div>
        <Navbar />
        <VidGalleryContent />
        <Footer />
      </div>
    </>
  );
}

export default VideosGallery;